/* eslint-disable no-dupe-keys */
export default {
  product_return_application: {
    name: '商品退款申请',
    // 属性（一般与对象内容匹配）
    prop: {
      trade_number: '申请单号',
      user: '用户',
      product_order: '商品订单',
      product: '商品',
      service_provider: '商家',
      applied_money: '申请金额',
      applied_points: '退还积分',
      apply_type: '申请类型',
      apply_reason: '申请原因',
      description: '申请说明',
      status: '状态',
      created_at: '申请时间',
      updated_at: '更新时间',
      points: '积分',
      applicant: '申请人'
    },
    // Enum的属性
    apply_types: {
      return_money: '退款',
      return_goods: '退货退款'
    },
    statuses: {
      pending: '待处理',
      processing: '待转账',
      complete: '已完成',
      rejected: '已拒绝',
      cancelled: '已取消'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '退款/订单单号/用户手机号'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    titles: {
      base_info: '基础信息',
      order_info: '商品订单',
      total_applied_money: '列表总金额',
      total_applied_money_tips: '不含已取消、已拒绝金额'
    },
    transitions: {
      pass: '审核通过',
      transfer: '转账',
      reject: '拒绝',
      cancel: '取消'
    }
  }
}
